<template>
  <main>
    <OnePager v-bind="extendedOnePageProps" />
  </main>
</template>

<script>
import OnePager from '@/components/OnePager'
import { MembershipTypes } from '@/enums/member'
import { OnePagerTypes } from '@/enums/signup'
import OnePagerMixin from '@/mixins/onepager'
import { SET_FORM_FIELD } from '@/utils/store/mutationTypes'

export default {
  name: 'MenOriginalsSignupOnePagerChooseDesign',
  layout: 'minimal',
  components: {
    OnePager
  },
  middleware: ({ store }) => {
    store.commit(`signup/${SET_FORM_FIELD}`, { key: 'membershipType', value: MembershipTypes.menOriginals })
    store.commit(`signup/${SET_FORM_FIELD}`, { key: 'freeMembershipType', value: MembershipTypes.menOriginals })
  },
  mixins: [OnePagerMixin({ fetchLatestDesign: true, type: OnePagerTypes.withDesignChoice })],
  computed: {
    onePagerType () {
      return OnePagerTypes.withDesignChoice
    },
    extendedOnePageProps () {
      return {
        ...this.onePageProps,
        onePagerType: this.onePagerType
      }
    }
  }
}
</script>
